<template>
  <div id="kanbancenterwrap">
    <div @click="exit" class="bbtn" style="left: 210px">
      <div style="transform: skewX(40deg)" class="bbtnbtn"></div>
      <a>进入系统</a>
    </div>
    <div id="kanbancenter" style="background:url(static/kanbantop.png);background-size: 100% 100%;">
      <h1>{{ $store.state.csr.name }}</h1>
      <ul v-if="false">
        <li :class="{active:now==x.id}" @click="now = x.id;$emit('now',x.id)" v-for="(x, index) in list" :key="index">{{ x.name }}</li>
      </ul>
    </div>
    <div @click="kanbanScreen" class="bbtn" style="right: 210px">
      <div style="transform: skewX(-40deg)" class="bbtnbtn"></div>
      <a>{{ $store.state.isFullScreen ? "退出全屏" : "进入全屏" }}</a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

      now: 1,
      list: [
        {
          name: '车辆总览',
          id: 1
        }, {
          name: '调度总览',
          id: 2
        }, {
          name: '费用总览',
          id: 3
        }, {
          name: '趟次总览',
          id: 4
        }
      ],
    };
  },
  methods: {
    open() {
      this.openGroup = true;
    },
    exit() {
      this.$router.push({
        path: "/carLocate",
        now: 0
      });
    },
    kanbanScreen() {
      document.getElementById("fullScree").click();
    },
  },
  mounted() {
 
  },
};
</script>
<style>
#kanbancenterwrap {
  width: 100%;
  display: flex;
  position: relative;
}

#kanbancenterwrap .bbtn {
  width: 180px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  text-align: center;
  top: 4px;
}

#kanbancenterwrap .bbtnbtn {
  width: 100%;
  height: 100%;
  cursor: pointer;
  margin-right: 10px;
  left: 140px;
  border: solid 2px #4884f4;
  box-shadow: 4px 4px 10px #2585cf inset;
}

#kanbancenterwrap .bbtn:hover .bbtnbtn {
  border: solid 2px #84afff;
  box-shadow: 4px 4px 10px #4fb2fe inset;
}

#kanbancenterwrap .bbtn a {
  font-size: 16px;
  top: 0;
  position: absolute;
  width: 150px;
  left: 0;
  color: aqua;
  display: block;
  width: 100%;
  height: 100%;
}

#kanbancenter {
  width: 1100px;
  height: 70px;
  text-align: center;
  position: relative;
  margin: auto;
  background-size: 100% 100%;
}

#kanbancenter h1 {
  margin-top: 18px;
  font-size: 28px;
  position: relative;
  z-index: 2;
  color: #93d4ff;
}

#kanbancenter ul {
  width: 360px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

#kanbancenter ul li {
  margin: 0 5px;
  display: inline-block;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}

#kanbancenter ul li.active {
  color: #dedede;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/kanbanselectGroup.vue